import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type TiktokProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Tiktok = ({ size = 24, width, height, alt = '', style, ...props }: TiktokProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(0.175092 0.249995) scale(0.979167)',
        },
        [
          h(
            'path',
            {
              d: 'M17.177 8.66299C18.7724 9.80975 20.6882 10.4255 22.653 10.423V6.47799C22.266 6.47799 21.881 6.43799 21.503 6.35699V9.46099C19.538 9.46392 17.6218 8.84853 16.026 7.70199V15.75C16.026 19.776 12.774 23.039 8.76297 23.039C7.32239 23.0411 5.9142 22.6117 4.71997 21.806C5.39444 22.5009 6.20168 23.0532 7.09375 23.4301C7.98583 23.807 8.94455 24.0008 9.91297 24C13.924 24 17.177 20.737 17.177 16.71V8.66399V8.66299ZM18.595 4.68499C17.7832 3.7962 17.2851 2.66584 17.177 1.46699V0.959991H16.087C16.2207 1.72195 16.5131 2.44729 16.9451 3.089C17.3772 3.73071 17.9393 4.27446 18.595 4.68499ZM7.25697 18.718C6.81591 18.1374 6.57771 17.4281 6.57897 16.699C6.57827 16.1758 6.70096 15.6598 6.93706 15.1928C7.17316 14.7259 7.51603 14.3212 7.93784 14.0116C8.35964 13.7021 8.8485 13.4963 9.36473 13.411C9.88097 13.3258 10.41 13.3635 10.909 13.521V9.48999C10.5283 9.43746 10.1441 9.41505 9.75997 9.42299V12.561C9.26102 12.4035 8.73197 12.3658 8.21573 12.451C7.6995 12.5363 7.21064 12.7421 6.78883 13.0516C6.36703 13.3612 6.02416 13.7659 5.78806 14.2328C5.55196 14.6998 5.42927 15.2158 5.42997 15.739C5.42997 17.041 6.17297 18.169 7.25697 18.718Z',
              fill: '#FF004F',
            },
          ),
          h(
            'path',
            {
              d: 'M16.0259 7.70299C17.6218 8.84947 19.5379 9.46485 21.5029 9.46199V6.35799C20.3828 6.11723 19.3661 5.53227 18.5949 4.68499C17.9393 4.27441 17.3772 3.73065 16.9452 3.08895C16.5131 2.44725 16.2207 1.72193 16.0869 0.959991H13.2239V16.71C13.2226 17.5908 12.8722 18.4352 12.2496 19.0582C11.6269 19.6813 10.7828 20.0321 9.90193 20.034C9.3893 20.0341 8.88363 19.9154 8.42467 19.687C7.96571 19.4587 7.56599 19.127 7.25693 18.718C6.70646 18.4392 6.24415 18.0131 5.92142 17.4871C5.59869 16.9612 5.4282 16.356 5.42893 15.739C5.42823 15.2158 5.55091 14.6998 5.78701 14.2328C6.02312 13.7659 6.36598 13.3612 6.78779 13.0516C7.2096 12.7421 7.69846 12.5363 8.21469 12.451C8.73092 12.3658 9.25998 12.4035 9.75893 12.561V9.42299C5.81893 9.50499 2.64893 12.736 2.64893 16.711C2.64893 18.695 3.43893 20.493 4.71993 21.807C5.91415 22.6127 7.32234 23.0421 8.76293 23.04C12.7749 23.04 16.0259 19.776 16.0259 15.75V7.70399V7.70299Z',
              fill: 'black',
            },
          ),
          h(
            'path',
            {
              d: 'M21.503 6.358V5.518C20.4746 5.51975 19.4665 5.231 18.595 4.685C19.3659 5.5326 20.3828 6.11762 21.503 6.358ZM16.087 0.96C16.0609 0.809877 16.0408 0.658752 16.027 0.507V0H12.074V15.75C12.0729 16.6309 11.7227 17.4755 11.1 18.0985C10.4773 18.7216 9.63291 19.0724 8.75201 19.074C8.2326 19.0747 7.72036 18.9527 7.257 18.718C7.56607 19.127 7.96579 19.4587 8.42475 19.687C8.8837 19.9154 9.38938 20.0342 9.902 20.034C10.7827 20.0321 11.6267 19.6814 12.2493 19.0586C12.8719 18.4358 13.2224 17.5917 13.224 16.711V0.96H16.087ZM9.76 9.423V8.53C9.42994 8.48466 9.09717 8.46194 8.764 8.462C4.75201 8.462 1.5 11.725 1.5 15.751C1.49862 16.9472 1.79163 18.1253 2.35318 19.1814C2.91474 20.2375 3.72758 21.1393 4.72001 21.807C3.38997 20.4445 2.64684 18.615 2.65 16.711C2.65 12.737 5.82 9.505 9.76 9.423Z',
              fill: '#00F2EA',
            },
          ),
        ],
      ),
    ],
  );

export default Tiktok;
